import { FormProvider } from 'react-hook-form';
import { TaskView } from '@nexelem/graphne-api';
import { SingleDetailEditable } from '../../../../../../components/atoms/SingleDetail/SingleDetailEditable';
import { AddTaskToPlanForm } from './AddTaskToPlanForm';
import { useAddTaskForm } from './useAddTaskForm';
import { useCustomTranslation } from '../../../../../../hooks/useCustomTranslation';

type ProductionTaskCardFormProps = {
  task: TaskView;
  onCancel: () => void;
  onSuccess: () => void;
};

export const ProductionTaskCardForm = ({ task, onCancel, onSuccess }: ProductionTaskCardFormProps) => {
  const { id: taskId, name: taskName, queue, start, end, releaseDate } = task;
  const { tWrapper } = useCustomTranslation('products.productionPlan.taskDetailsDrawer');

  const title = <span className="text-t16-b text-text-primary">{tWrapper('task')}</span>;

  const { form, onSubmit, isPending } = useAddTaskForm({
    taskId,
    taskName,
    onSuccess,
    queueId: queue?.id,
    start,
    end,
    isLocked: releaseDate.isLocked,
  });

  return (
    <form onSubmit={form.handleSubmit(onSubmit)}>
      <FormProvider {...form}>
        <SingleDetailEditable isPending={isPending} title={title} onCancel={onCancel}>
          <AddTaskToPlanForm size="small" task={task} />
        </SingleDetailEditable>
      </FormProvider>
    </form>
  );
};
